import { CarClaimDetails } from './view';

export { default as carClaimDetailsReducer } from './reducer';
export { default as carClaimDetailsSaga } from './saga';
export { selectCarClaim } from './selector';

export default CarClaimDetails;
